import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';

interface IModalLegalProps {
  open: boolean;
  toggle: any;
}

export default function ModalLegal(props: IModalLegalProps) {
  const { open, toggle } = props;

  return (
    <Modal isOpen={open} size="lg">
      <div className="modal-header">
        <h5 className="modal-title mb30">Notas Legales</h5>
        <h6 className="text-primary">Seguro de Hospitalización</h6>
        <button type="button" className="close" onClick={toggle(false)}>
          <i className="material-icons">close</i>
        </button>
      </div>
      <ModalBody>
        <ul className="px-14">
          <li>
            <p>UF calculada al 01/07/2020 y el precio en $ es referencial.</p>
            <p>
              Intermedia Seguros Falabella Corredores Limitada, quien asume las
              responsabilidades propias de la intermediación. Asegura MetLife
              Chile Seguros de Vida S.A. Los beneficios de video consulta y
              descuento en farmacias no constituyen coberturas de seguros.
              Beneficio de Video Consulta es de exclusiva responsabilidad de
              SALUD MODERNA DE CHILE SPA (MEDICLIC). Descuento en farmacias es
              de exclusiva responsabilidad de Farmacias Ahumada. Las coberturas
              contratadas se rigen según las condiciones generales, cuyos
              modelos se encuentran depositados en Comisión para el Mercado
              Financiero bajo los POL 2 2013 1335 Y CAD 2 2013 1338 y pueden ser
              consultadas en el sitio web&nbsp;
              <a
                href="//www.cmfchile.cl"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.cmfchile.cl
              </a>
            </p>
            <p>
              El asegurado podrá poner término al seguro en cualquier momento
              mediante comunicación a Seguros Falabella, en cuyo caso tendrá
              derecho sólo a la proporción de la prima contratada que comprende
              al período efectivamente no cubierto por el seguro.
            </p>
            <p>
              El pago con tarjeta de crédito puede tener costos asociados.
              Consulta al emisor para mayor información. Derecho a retracto de
              35 días contados desde la contratación. Seguro voluntario.
            </p>
          </li>
        </ul>
      </ModalBody>
    </Modal>
  );
}
